import React from "react"
import Layout from "../components/app/layout"
import SEO from "../components/seo"
import Header from "../components/home/Header"
import About from "../components/home/About"
import Services from "../components/home/Services"
import Newsletter from "../components/home/Newsletter"
import Contact from "../components/home/Contact"
// import MarkerMap from "../components/home/MarkerMap"
import Team from "../components/home/Team"

const IndexPage = () => (
  <Layout id="page-top">
    <SEO title="Home" />
    <Header />
    <About />
    <Services />
    <Newsletter />
    {/*<MarkerMap />*/}
    <Team />
    <Contact />
  </Layout>
)

export default IndexPage
